import type { InputHTMLAttributes } from "react";
import { Search } from "lucide-react";

type SearchBarProps = InputHTMLAttributes<HTMLInputElement>;

export function SearchBar({ className = "", ...rest }: SearchBarProps) {
  return (
    <div className={`relative ${className}`}>
      <Search
        size={18}
        strokeWidth={2.25}
        className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-[#8E8E93]"
      />
      <input
        type="search"
        placeholder="Games, Apps, Stories and More"
        className="h-9 w-full rounded-[10px] bg-[#767680]/[0.12] pl-8 pr-3 text-[17px] text-neutral-900 placeholder:text-[#8E8E93] focus:outline-none [&::-webkit-search-cancel-button]:appearance-none"
        {...rest}
      />
    </div>
  );
}